/* ROUTINE FINDER PRICE UPDATE: current Shopify prices; routine discount remains 10% */
(function(){
  function apply(){
    var root=document.querySelector('[data-routine-result], .hue-routine-finder, #hue-routine-finder');
    if(!root) return;
    var map={"LUMIN-C Radiance Renew Face Cleanser":16700,"Vivid Glow Hydrating Face Milk":16125,"LUMIN-C Radiance Renew Face Serum":21500,"LUMIN-C Radiance Renew Face Toner":21500,"Daily Defense SPF 50 Mineral Sunscreen":21500};
    var text=root.textContent||'';
    if(text.indexOf('Glow Boost')<0 && text.indexOf('GLOW BOOST')<0) return;
    var retail=97325, price=87592.5, save=9732.5;
    var els=root.querySelectorAll('*');
    for(var i=0;i<els.length;i++){
      var e=els[i], t=(e.textContent||'').trim();
      if(t==='Retail value:' && e.parentElement){ var p=e.parentElement; p.innerHTML=p.innerHTML.replace(/₦[0-9,]+/,'₦97,325'); }
      if(t==='Routine price:' && e.parentElement){ var p2=e.parentElement; p2.innerHTML=p2.innerHTML.replace(/₦[0-9,]+/,'₦87,593'); }
      if(t==='You save:' && e.parentElement){ var p3=e.parentElement; p3.innerHTML=p3.innerHTML.replace(/₦[0-9,]+/,'₦9,733'); }
    }
  }
  var n=0, timer=setInterval(function(){apply(); if(++n>40) clearInterval(timer);},250);
})();